import React, { useRef, useLayoutEffect, useEffect } from 'react';
import cx from 'classnames';
import { faCheck, faMinus } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'js/components';

export function Checkbox({
  labelClass,
  checked,
  indeterminate = false,
  children,
  onChange = () => {},
  ref,
  reverse = false,
  ...props
}) {
  const icon = indeterminate ? faMinus : faCheck;
  const inputRef = useRef(null);

  useEffect(() => {
    if (ref) {
      ref.current = inputRef.current;
    }
  }, [ref, inputRef]);

  useLayoutEffect(() => {
    inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <div
      className={cx('custom-checkbox', { reverse: reverse })}
      role="presentation"
    >
      <label className={labelClass}>
        {reverse && children}
        <input
          type="checkbox"
          checked={checked ?? false}
          onChange={onChange}
          ref={inputRef}
          {...props}
        />
        <span className="decorator">
          <Icon icon={icon} className="icon" />
        </span>
        {!reverse && children}
      </label>
    </div>
  );
}

export default Checkbox;
